import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

import styles from './styles.module.less';

const CustomizeCardButton = ({ handleCustomizeClick, disabled, mobileFullWidth, className }) => {
  return (
    <ButtonV2
      className={cx('btn-wide', styles.customizeCardButton, className, {
        [styles.mobileFullWidth]: mobileFullWidth,
      })}
      onClick={handleCustomizeClick}
      disabled={disabled}
    >
      <span className="hidden-xs">Customize This Design</span>
      <span className="visible-xs">Customize Design</span>
    </ButtonV2>
  );
};

CustomizeCardButton.propTypes = {
  handleCustomizeClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  mobileFullWidth: PropTypes.bool,
  className: PropTypes.string,
};

export default CustomizeCardButton;
